export const getCurrencyOption = currency => ({
    value: currency.currency,
    label: `${currency.currency} (${currency.symbol})`,
})
